<template>
  <div>
    <v-progress-linear
      v-if="loading"
      indeterminate
    />
    <v-card>
      <v-toolbar
        flat
        color="primary"
        dark
        dense
      >
        <v-icon left>mdi-reply</v-icon>
        Auto Reply
        <v-spacer />
      </v-toolbar>
      <v-expand-transition>
        <v-card-text
          v-if="!loading"
        >
          <v-alert
            :value="true"
            type="info"
            outline
          >
            Enable this option to automatically reply to all incoming contact messages with a predefined response.
            <br /><br />{{ app_name }} will send this auto reply once every two hours per Contact.
          </v-alert>

          <v-switch
            label="Enable Auto Reply"
            v-model="orgSettings.auto_reply"
          />

          <v-form
            v-show="orgSettings.auto_reply"
            v-model="valid"
            ref="autoreply_form"
          >
            <v-text-field
              v-model="orgSettings.auto_reply_subject"
              label="Auto Reply Subject"
              :rules="[v => !!v || 'A Subject is required']"
              required
              hint="Required; The subject to give your automatic response"
              persistent-hint
              style="padding-bottom: 15px"
            />
          </v-form>
          <div
            v-show="orgSettings.auto_reply"
            style="padding-bottom: 10px"
          >
            Message Body:
          </div>
          <Editor
            v-show="orgSettings.auto_reply"
            ref="htmlEditor"
            :html="orgSettings.auto_reply_body"
            :placeholders="placeholders"
            height="250"
            :min="25"
          />
        </v-card-text>
      </v-expand-transition>
      <v-card-actions>
        <div
          v-if="htmlerr"
          style="display: inline-block"
        >
          Check your Subject and Message Body and Try Again
        </div>
        <v-spacer />
        <v-btn
          :disabled="loading || (orgSettings.auto_reply && !valid)"
          color="primary"
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from '@/api'
import Editor from '@/components/admin/Editor'
import { Sketch } from 'vue-color'
import appMixin from '@/components/global/appmixin.js'

export default {
  name: 'OrgCommunicationAutoReply',
  mixins: [
    appMixin
  ],
  components: {
    Editor,
    'sketch-picker': Sketch,
  },
  data () {
    return {
      loading: false,
      valid: true,
      orgSettings: {},
      htmlerr: false,
      placeholders: [
        {
          scope: "contact",
          variable: "first_name",
          name: "Contact: First Name",
        },
        {
          scope: "contact",
          variable: "middle_name",
          name: "Contact: Middle Name",
        },
        {
          scope: "contact",
          variable: "last_name",
          name: "Contact: Last Name"
        },
        {
          scope: "contact",
          variable: "full_name",
          name: "Contact: Full Name (Last, Middle First)"
        },
        {
          scope: "contact",
          variable: "cuid",
          name: "Contact: CUID"
        },
        {
          scope: "contact",
          variable: "email",
          name: "Contact: Email"
        },
        {
          scope: "contact",
          variable: "phone",
          name: "Contact: Phone"
        }
      ]
    }
  },
  created () {
    this.documentTitle('Organization Settings')
    this.fetch()
  },
  methods: {
    fetch () {
      this.loading = true
      api.auth.organization.get()
        .then(org => {
          this.orgSettings = org
          delete this.orgSettings.logo
          delete this.orgSettings.icon
          this.loading = false
        })
    },
    save () {
      this.failed = false
      this.loading = true
      this.htmlerr = false
      if ((this.$refs.autoreply_form.validate() && this.$refs.htmlEditor.getCharCount() > 20) || !this.orgSettings.auto_reply) {
        this.orgSettings.auto_reply_body = this.$refs.htmlEditor.getHTML().replace(/<p>/g, "").replace(/<\/p>/g, "<br>").replace(/(<br>*)$/,'')
        api.auth.organization.save(this.orgSettings)
          .then(() => {
            this.$router.go()
          })
          .catch(() => {
            alert('Something went wrong attempting to update organization settings.')
            this.loading = false
          })
      } else {
        this.loading = false
        this.htmlerr = true
      }
    }
  }
}
</script>

<style scoped>
  .details span {
    display:block;
    padding:3px;
  }

  .uploadHover {
    position: absolute;
    padding:50px;
    width:100%;
    height:100%;
    top:40px;
    bottom:0;
    background:rgba(255,255,255,0);
    opacity:0.05;
  }

  .uploadHover span {
    font-size:18px;
    text-align:center;
  }

  .uploadHover:hover {
    opacity:1;
    background:rgba(255,255,255,0.5);
  }
</style>
